import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ce7cc5b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modalBackdrop flex absolute popUpZIndex" }
const _hoisted_2 = { class: "c4c-modal" }
const _hoisted_3 = { class: "panelheader" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headerTitle" }, "Contract Labor Management", -1))
const _hoisted_5 = { "aria-hidden": "true" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text" }, "Close", -1))
const _hoisted_7 = {
  id: "contractLaborManagementModal",
  class: "panleBody scrollBar border"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Single Day ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Multi Day ", -1))
const _hoisted_11 = {
  key: 0,
  id: "contractLaborRequestSingleDayWrapper",
  class: "panelTabData scrollBar",
  role: "tabpanel"
}
const _hoisted_12 = {
  key: 1,
  id: "contractlaborManagementRequestMultiDayWrapper",
  class: "panelTabData scrollBar",
  role: "tabpanel"
}
const _hoisted_13 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_tab = _resolveComponent("neu-tab")!
  const _component_neu_tablist = _resolveComponent("neu-tablist")!
  const _component_SingleDay = _resolveComponent("SingleDay")!
  const _component_MultiDay = _resolveComponent("MultiDay")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("a", {
          href: "#",
          class: "closeBtn neu-tooltip",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, [
          _createElementVNode("i", _hoisted_5, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'close'],
              size: "lg"
            })
          ]),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.isShowTabList)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_neu_tablist, {
                value: _ctx.selectedTab,
                class: "mx-4 tabList"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_neu_tab, {
                    white: "",
                    tab: "SingleDay",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setSelectedTab('SingleDay')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_neu_tab, {
                    white: "",
                    tab: "MultiDay",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setSelectedTab('MultiDay')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"]),
              (_ctx.isSingleDayVisible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_SingleDay, { singleDayInput: _ctx.tabInput }, null, 8, ["singleDayInput"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isMultiDayVisible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_MultiDay, { multiDayInput: _ctx.tabInput }, null, 8, ["multiDayInput"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true)
  ]))
}